<template>
  <div ref="PurchaseDashboardDetailpdf" id="PurchaseDashboardDetailpdf">
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name || "Purchase Dashboard - Detail View" }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.ModuleTypeFilter ||
              Filter.PaymentTypeFilter ||
              Filter.JobNoFilter ||
              Filter.TransactionNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.ModuleTypeFilter ||
                  Filter.PaymentTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.TransactionNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

            <!-- Client-side Export using xlsx -->
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              @click="exportToExcelClient" size="sm" variant="success"
              style="font-size: 0.675rem">
              Export (Client XLSX)
            </b-button>

            <!-- PDF Export -->
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              @click="generatePaymentPDF" size="sm" variant="info"
              style="font-size: 0.675rem">
              <i class="fa fa-cloud-download" aria-hidden="true"></i> PDF
            </b-button>

          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date Type</label>
                  <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                    option-text="text" placeholder="Select Date Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Module Type</label>
                  <model-list-select :list="moduleOptions" v-model="Filter.ModuleTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Module Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Payment Type</label>
                  <model-list-select :list="payTypeOptions" v-model="Filter.PaymentTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Payment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Job NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                    id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transaction No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Transaction No Filter"
                    id="TransactionNoFilter" name="TransactionNoFilter" autocomplete="off"
                    v-model="Filter.TransactionNoFilter" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Transport Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Shipment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                    v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                    v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                    v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                    v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="text"
                    option-text="value" placeholder="Select Status"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="paymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">

                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="TransactionNo" slot-scope="row1">
                  <div>
                    <strong>Trans No:</strong> {{ row1.item.TransactionNo || "" }}<br />
                    <strong>Request Date:</strong> {{ row1.item.CreatedAt || "" }}<br />
                    <strong>Request By:</strong> {{ row1.item.RequestedBy || "" }}<br />
                    <strong>Status:</strong>
                    <b-badge :variant="row1.item.IsPaymentDone==1 ? 'success' : 'warning'">
                      {{ row1.item.IsPaymentDone==1 ? 'Paid' : 'Pending' }}
                    </b-badge>
                    <strong>Approval Status:</strong>
                    <b-badge :variant="row1.item.approval_status=='APPROVED' ? 'success' : 'warning'">
                      {{ row1.item.approval_status }}
                    </b-badge>
                  </div>
                </template>

                <template slot="JobNo" slot-scope="row1">
                  <div>
                    <strong>Job No:</strong> {{ row1.item.JobNo || "" }}<br />
                    <strong>Job Date:</strong> {{ row1.item.JobDate || "" }}<br />
                    <strong>Job Raised By:</strong> {{ row1.item.JobRaisedBy || "" }}<br />
                    <strong>Branch:</strong> {{ row1.item.Branch || "" }}<br />
                    <strong>Job Type:</strong> {{ row1.item.MJobType || "" }}
                  </div>
                </template>

                <template slot="ClientName" slot-scope="row1">
                  <div>
                    <strong>Sline Name:</strong> {{ row1.item.SlineName || "" }}<br />
                    <strong>Client:</strong> {{ row1.item.ClientName || "" }}
                  </div>
                </template>

                <template slot="Location" slot-scope="row1">
                  <div>
                    <strong>POR:</strong> {{ row1.item.POR || "" }}<br />
                    <strong>POL:</strong> {{ row1.item.POL || "" }}<br />
                    <strong>POD:</strong> {{ row1.item.POD || "" }}<br />
                    <strong>FPOD:</strong> {{ row1.item.FPOD || "" }}
                  </div>
                </template>

                <template slot="PaymentDetails" slot-scope="row1">
                  <div>
                    <strong>Payment Type:</strong> {{ getPaymentTypeText(row1.item.PaymentType) }}<br />
                    <strong>Module Type:</strong> {{ getModuleTypeText(row1.item.ModuleType) }}<br />
                    <strong>Transport Type:</strong> {{ row1.item.JobTransportType || "" }}<br />
                    <strong>Container Type:</strong> {{ row1.item.JobTContainerType || "" }}
                  </div>
                </template>

                <template slot="Amount" slot-scope="row1">
                  <div>
                    <strong v-if="row1.item.payment_type=='Additional Task'">Bill to SHIPPER: {{ (row1.item.sc_category) }}<br /></strong>
                    <strong v-if="row1.item.payment_type=='Additional Task'">Selling Amount: {{ (row1.item.selling_amt) }}<br /></strong>
                    <strong v-if="row1.item.payment_type=='Additional Task'">Remark: {{ (row1.item.sc_remark) }}<br /></strong>
                    <strong>Inv Date:</strong> {{ (row1.item.inv_date) }}<br />
                    <strong v-if="row1.item.payment_type=='Additional Task'">Inv Amount: {{ formatAmount(row1.item.inv_amt || row1.item.totalPayAmt || row1.item.TotalPayAmt || 0) }}<br /></strong>
                    <strong>Pay Amount:</strong> {{ formatAmount(row1.item.inv_pay_amt || row1.item.totalPayAmt || row1.item.TotalPayAmt || 0) }}<br />
                    <strong>Currency:</strong> {{ row1.item.currency || "" }}<br />
                    <strong>Pay Mode:</strong> {{ row1.item.inv_pay_mode || "" }}<br />
                    <strong>Pay Ref No:</strong> {{ row1.item.inv_pay_ref_no || "" }}<br />
                    <strong>Pay Date:</strong> {{ row1.item.inv_pay_date || "" }}
                    <div v-if="row1.item.inv_doc_url && row1.item.payment_type!='Additional Task'">
                      <b-button size="xs" style="font-size: 0.675rem" variant="warning"
                        :href="String(row1.item.inv_doc_url).startsWith('http') ? row1.item.inv_doc_url : `${docURL}${row1.item.inv_doc_url}`"
                        target="_blank" rel="noopener">
                        View Doc
                      </b-button>
                    </div>
                  </div>
                </template>

                <template slot="AdditionalInfo" slot-scope="row1">
                  <div>
                    <strong>Invoice Type:</strong> {{ row1.item.invoiceType || "" }}<br />
                    <strong>Invoice Category:</strong> {{ row1.item.invoiceCategory || "" }}<br />
                    <strong>Due Date:</strong> {{ row1.item.dueDate || "" }}<br />
                    <strong>SOB Date:</strong> {{ row1.item.sobDate || "" }}<br />
                    <strong>HBL:</strong> {{ row1.item.HBL || "" }}<br />
                    <strong>MBL:</strong> {{ row1.item.MBL || "" }}
                  </div>
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE_DOC } from "../../helper/constant";
import PaymentRequestService from "../../services/PaymentRequestService";
import { exportPaymentListToExcel } from "../../helper/ExcelExportHelper";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
    ];
    
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    Promise.all(storePromises)
      .then(() => delay(5000))
      .then(() => {
        this.$store.dispatch("setCurrentRoute", "/ffexpdash/purchase-dash-detail");
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getPaymentList("Normal", "0", "0", "1", "1");
        }
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      paymentList: [],
      totalData: 0,
      payTypeOptions: [
        {
          text: "",
          value: "All",
        },
        {
          Val: "0",
          Text: "Sline",
        },
        {
          Val: "1",
          Text: "Expense",
        },
        {
          Val: "2",
          Text: "Additional Task",
        },
      ],
      moduleOptions: [
        {
          Val: "0",
          Text: "Normal",
        },
        {
          Val: "1",
          Text: "consolidation",
        },
        {
          Val: "2",
          Text: "MISC",
        },
        {
          Val: "3",
          Text: "YARD",
        },
        {
          Val: "4",
          Text: "IB",
        },
      ],
      PaymentFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "TransactionNo",
          mainkey: "TransactionNo",
          label: "Transaction Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/Sline",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Location",
          mainkey: "Location",
          label: "Location Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "PaymentDetails",
          mainkey: "PaymentDetails",
          label: "Payment Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Amount",
          mainkey: "Amount",
          label: "Amount Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "AdditionalInfo",
          mainkey: "AdditionalInfo",
          label: "Additional Info",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
      isInfiniteAppend: false,
      hasMore: true,
      scrollThreshold: 200,
      statusList: [
        {
          text: 0,
          value: "PENDING",
        },
        {
          text: 1,
          value: "COMPLETED",
        },
        {
          text: 2,
          value: "All",
        },
      ],
      refreshInterval: null, // Store interval ID for auto-refresh
    };
  },
  components: {
    CustomLoader,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {},
  watch: {},
  mounted() {
    // Start auto-refresh polling every 3 minutes (180000 milliseconds)
    this.startAutoRefresh();
  },
  beforeDestroy() {
    // Clear the interval when component is destroyed to prevent memory leaks
    this.stopAutoRefresh();
  },
  methods: {
    startAutoRefresh() {
      // Clear any existing interval first
      this.stopAutoRefresh();
      
      // Set up interval to refresh data every 3 minutes
      this.refreshInterval = setInterval(() => {
        // Only refresh if not currently loading and component is still mounted
        if (!this.isLoading) {
          // Preserve current page and filters when auto-refreshing
          this.getPaymentList("Normal", "0", "0", "1", "1");
        }
      }, 180000); // 3 minutes = 180000 milliseconds
    },
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    goBack() {
      window.history.go(-1);
    },
    getPaymentTypeText(type) {
      const types = {
        "0": "Sline",
        "1": "Expense",
        "2": "Additional Task",
      };
      return types[String(type)] || "N/A";
    },
    getModuleTypeText(type) {
      const types = {
        "0": "Normal",
        "1": "consolidation",
        "2": "MISC",
        "3": "YARD",
        "4": "IB",
      };
      return types[String(type)] || "N/A";
    },
    formatAmount(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return val || "0.00";
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    getCurrentDateTime() {
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      const now = new Date();
      return now.toLocaleString("en-GB", options);
    },
    clearFilter() {
      this.Filter = {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getPaymentList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`;

      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`;
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate,
        endDate: endDate,
      };
    },
    getPaymentList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      if (!this.isInfiniteAppend) {
        this.totalData = 0;
        this.paymentList = [];
        this.hasMore = true;
      }
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        fromSearch: SEARCH,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        ExpImpType: this.ExpImpType,
        is_parent: "0",
        is_include_children: "0",
        is_payment_done: "0",
        is_children: "0",
        is_bookmark: "0",
        isAll:"0",
        payment_type: this.Filter.PaymentTypeFilter,
        module_type: this.Filter.ModuleTypeFilter,
        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.transportTypeFilter,
        shipmentTypeFilter: this.Filter.shipmentTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        branchFilter: this.Filter.branchFilter,
        dateRange: this.Filter.dateRange,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,
        approverByFilter: this.Filter.approverByFilter,
        single: "0",
        isList: 1,
      };
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      PaymentRequestService.getPurchaseExpense(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getPaymentList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalCount;
                this.paymentList = this.isInfiniteAppend ? this.paymentList.concat(data.data) : data.data;
                this.pagination.totalRows = data.pagination.totalCount;
                this.pagination.currentPage = data.pagination.currentPage;
                this.pagination.perPage = data.pagination.pageSize;
                if (data.pagination && typeof data.pagination.totalPages !== 'undefined') {
                  this.hasMore = Number(data.pagination.currentPage) < Number(data.pagination.totalPages);
                } else {
                  this.hasMore = this.paymentList.length < this.totalData;
                }
              }
            }
          }
          this.isLoading = false;
          this.isInfiniteAppend = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
          this.isLoading = false;
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getPaymentList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getPaymentList("Excell", "0", "0", "1", "1");
    },
    async exportToExcelClient() {
      const payload = {
        type: 'Excel',
        currentPage: 1,
        page: 1,
        perPage: this.totalData || 10000,
        pageSize: this.totalData || 10000,
        filter: this.Filter,
        generateExcel: '1',
        is_parent: '0',
        is_include_children: '0',
        is_payment_done: '0',
        is_children: '0',
        is_bookmark: '0',
        payment_type: this.Filter.PaymentTypeFilter,
        module_type: this.Filter.ModuleTypeFilter,
        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.TransportTypeFilter,
        shipmentTypeFilter: this.Filter.ShipemntTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        branchFilter: this.Filter.branchFilter,
        dateRange: this.Filter.dateRange,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,
      };

      const fileName = 'purchase-dashboard-detail.xlsx';

      await exportPaymentListToExcel(
        payload,
        fileName,
        true,
        () => {
          this.isLoading = true;
        },
        () => {
          this.isLoading = false;
          this.alert.content = 'Excel file downloaded successfully!';
          this.$refs['addPop'].open();
        },
        (error) => {
          this.isLoading = false;
          this.alert.content = 'Failed to export Excel. Please try again.';
          this.$refs['addPop'].open();
          console.error('Export error:', error);
        }
      );
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    generatePaymentPDF() {
      let data = this.paymentList;
      const doc = new jsPDF("p", "mm", "a4");

      if (data.length > 0) {
        const table = document.createElement("table");
        table.innerHTML = `
        <thead>
          <tr>
            <th>SN.</th>
            <th>Trans No</th>
            <th>Job No</th>
            <th>Client</th>
            <th>Payment Type</th>
            <th>Request Date</th>
            <th>Status</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          ${data
            .map(
              (item, index) =>
                `<tr>
                  <td>${parseInt(index + 1)}</td>
                  <td>${item.TransactionNo || ""}</td>
                  <td>${item.JobNo || ""}</td>
                  <td>${item.ClientName || item.SlineName || ""}</td>
                  <td>${this.getPaymentTypeText(item.PaymentType)}</td>
                  <td>${item.CreatedAt || ""}</td>
                  <td>${item.IsPaymentDone == 1 ? "Paid" : "Pending"}</td>
                  <td>${this.formatAmount(
                    item.inv_amt ||
                      item.totalPayAmt ||
                      item.TotalPayAmt ||
                      item.inv_pay_amt ||
                      item.amount ||
                      0
                  )}</td>
                </tr>`
            )
            .join("")}
          <tr><td colspan='8'><b>Report Generated At : </b>${this.getCurrentDateTime()}</td></tr>
        </tbody>
      `;
        doc.autoTable({
          html: table,
          startY: 6,
          margin: { top: 4 },
          styles: { fontSize: 7 },
        });

        doc.save(
          "Purchase_Payment_List_Detail_" +
            moment().format("YYYY-MM-DD-HH-mm-ss") +
            ".pdf"
        );
      }
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}
</style>




// WEBPACK FOOTER //
// purchaseDashboardDetail.vue?6b1fbe6a